const { origin } = window.location;
const api = '/manager/api';

export default {
  contato: {
    assunto: `${origin}${api}/contato/assunto`,
    salvar: `${origin}${api}/contato/salvar`,
  },
  lojas: `${origin}${api}/loja`,
  cidades: `${origin}${api}/cidade`,
  nossa_gente: `${origin}${api}/nossa-gente`,
  imprensa: `${origin}${api}/imprensa`,
  transparencia: `${origin}${api}/transparencia`,
};
